import axios from "axios";
import { Loading, Notify } from "notiflix";
import { OTP_SENT, LOGIN_SUCCESS, USER_LOADED, AUTH_ERROR, LOGOUT, ACCOUNT_CREATED, AUTHENTICATION, VALIDATION, GUEST_LOGIN_SUCCESS, GUEST_MODAL, RESET_APP, RESET_FILTERS } from "./types";
import { APIURL } from "./config";
import { getSchoolInfo } from "./common";
// import setAuthToken from "../Utils/setAuthToken";

// Load User
// export const loadUser = () => async (dispatch) => {
//     if (localStorage.token) {
//         setAuthToken(localStorage.token);
//     }
//     try {
//         const res = await axios.get(`${APIURL}/api/schooladmin/info`);
//         dispatch({
//             type: USER_LOADED,
//             payload: res.data,
//         });
//     } catch (error) {
//         dispatch({
//             type: AUTH_ERROR,
//         });
//     }
// };

export const sendOTP = (data, cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/auth/login/authenticate`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ? res?.data?.message : "OTP sent successfully!"
         Notify.success(message);
         dispatch({
            type: OTP_SENT,
            payload: data?.mobile,
         });
         if (cb) cb({ step: 2, formData: { mobile: data.mobile } });
      } else if (res?.data?.code == 500) {
         dispatch({
            type: AUTHENTICATION,
            payload: res?.data,
         });
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      console.log("err >> ", err);
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const validateOTP = (data, cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/auth/login/validate`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         localStorage.setItem("kidex-sd-token", res?.headers["access-token"]);
         const message = res?.data?.message ? res?.data?.message : "logged in successfully!"
         Notify.success(message);
         dispatch({ type: LOGIN_SUCCESS, payload: res?.data?.body });
         dispatch(getSchoolInfo());
      } else if (res?.data?.message == "Account not found!") {
         localStorage.setItem("guest", true);
         dispatch({ type: GUEST_LOGIN_SUCCESS, payload: res?.data?.body, });
         dispatch(getSchoolInfo());
      } else if (res?.data?.code == 500) {
         dispatch({
            type: VALIDATION,
            payload: res?.data,
         });
         if (cb) cb();
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
      } else {
         Notify.warning("something went wrong");
      }
      dispatch({ type: RESET_FILTERS })
   } catch (err) {
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}

export const createAccount = (data, cb) => async dispatch => {
   const config = {
      headers: {
         'Accept': 'application/json',
         'Content-Type': 'application/json'
      }
   };
   try {
      Loading.standard();
      const res = await axios.post(`${APIURL}/api/account/create/school-person`, data, config);
      Loading.remove();
      if (res?.data?.status) {
         const message = res?.data?.message ? res?.data?.message : "Account information saved successfully."
         Notify.success(message);
         dispatch({
            type: ACCOUNT_CREATED,
            payload: res?.data,
         });
         if (cb) cb();
      } else if (res?.data?.message) {
         Notify.warning(res?.data?.message);
         dispatch({
            type: ACCOUNT_CREATED,
            payload: res?.data,
         });
      } else {
         Notify.warning("something went wrong");
      }
   } catch (err) {
      console.log("err >> ", err);
      Loading.remove();
      const message = err?.response?.data?.message ?? 'internal server error'
      Notify.failure(message);
   }
}
export const resetAuthentication = () => (dispatch) => {
   dispatch({ type: AUTHENTICATION, payload: {} });
};

export const resetValidation = () => (dispatch) => {
   dispatch({ type: VALIDATION, payload: {} });
};

export const resetOTPSend = () => (dispatch) => {
   dispatch({ type: OTP_SENT, payload: null });
};

export const setGuestModal = status => dispatch => {
   dispatch({ type: GUEST_MODAL, payload: status })
}

// Logout/Clear Profile
export const logout = () => (dispatch) => {
   dispatch({ type: LOGOUT, payload: {} });
};


